export default __webpack_public_path__ + "static/media/thanks@2x.56e46097.png";